import { ToneCardAPIModelImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardapimodel';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { DeleteFromWishlistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/wishlist/deletefromwishlist/deletefromwishlistdto';
import { DeleteFromWishlistResponse } from 'src/com/sixdee/crbtportal/core/api/wishlist/deletefromwishlist/deletefromwishlistresponse';
import { DeleteFromWishlistRequestImpl } from 'src/com/sixdee/crbtportal/core/api/wishlist/deletefromwishlist/deletefromwishlistrequest';


export class WishlistToneCardAPIModelImpl extends ToneCardAPIModelImpl
{
      deleteTone(toneDto: ToneDto): void 
      {
        let deleteFromWishlistDto = new DeleteFromWishlistDtoImpl();
        deleteFromWishlistDto.setIdentifier("DeleteFromWishList");
        deleteFromWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        deleteFromWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        deleteFromWishlistDto.setWishlistType("1");
        deleteFromWishlistDto.setCatagoryId(toneDto.getContentId());

        this.getAPIProcesssorFactory().getToneProcessorFactory()
        .getDeleteFromWishlist()
        .success((deleteFromWishlistResponse: DeleteFromWishlistResponse)=>
        {
            console.log("deleteWishList success ###############DeleteWISHLIST#################");
            this.getAPIModelHandler().onSuccess(deleteFromWishlistResponse.getAPIFeature(), 
            deleteFromWishlistResponse.getDescription(), deleteFromWishlistResponse.getDeleteFromWishlistDto());
          
         })
        .failure((deleteFromWishlistResponse: DeleteFromWishlistResponse)=>
         {
           this.getAPIModelHandler().onFailure(deleteFromWishlistResponse.getAPIFeature(), 
           deleteFromWishlistResponse.getDescription(), undefined);
         })
        .execute(new DeleteFromWishlistRequestImpl(deleteFromWishlistDto));
      }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/tones/wishlisttonecardapimodel.tsx